import React from "react";
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { txtA, txtE } from "../../../../Label/Lbl";
import { getTotalAmount } from "../../../../utils/utils";
import "../riyals.css"
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";

const useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
        border: "1px solid #888",
        borderRadius: 0,
        boxShadow: "none",
        overflow: "hidden",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
    },

    table: {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
    },

    cell: {
        border: "1px solid #888",
        padding: "0px 0px",
        // height: 33,
        boxSizing: "border-box",
        fontSize: 15,
        fontWeight: 600,
        color: "#252525",
        lineHeight: 1.4,

        [theme.breakpoints.down("xs")]: {
            padding: "5px 4px",
            fontSize: 11,
            overflowWrap: "anywhere",
        },
    },

    englishCell: {
        width: "40%",
        textAlign: "left",
        direction: "ltr",
        paddingLeft: "5px",
        paddingTop: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
        fontSize:"14px"
    },

    arabicCell: {
        width: "40%",
        textAlign: "right",
        direction: "rtl",
        paddingLeft: "0px",
        paddingTop: "0px",
        paddingRight: "5px",
        paddingBottom: "0px",
        fontSize:"14px"
    },

    amountCell: {
        width: "20%",
        textAlign: "right",
        direction: "ltr",
        padding: "0px",
        paddingLeft: "0px",
        paddingTop: "0px",
        paddingRight: "5px",
        paddingBottom: "0px",
        whiteSpace: "nowrap",
    },

    headerCell: {
        backgroundColor: "#ededed",
        fontWeight: 700,
    },

    amountContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 12,
        whiteSpace: "nowrap",

        [theme.breakpoints.down("xs")]: {
            gap: 4,
        },
    },

    currency: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        flexShrink: 0,
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1,

        [theme.breakpoints.down("xs")]: {
            width: 16,
            fontSize: 15,
        },
    },

    amount: {
        minWidth: 90,
        textAlign: "right",
        fontVariantNumeric: "tabular-nums",
        fontWeight: 700,

        [theme.breakpoints.down("xs")]: {
            minWidth: 0,
        },
    },

    totalRow: {
        "& td": {
            fontWeight: 700,
        },
    },
}));


const totalsRe_Disc = (sta, tax, locInv) => [
    {
        id: 1,
        en: "Total (Excluding VAT)",
        ar: "الإجمالي (باستثناء ضريبة القيمة المضافة)",
        amount:locInv?.invs?.tot_sale,
    },
    {
        id:6,
        en: txtE.discount,
        ar: "خصم دفعة مقدمة",
        amount: sta.tot.discount,
    },
    {
        id:7,
        en: "Total Taxable Amount",
        ar: "الإجمالي الخاضع للضريبة",
        amount: locInv?.invs?.amountAfterDisc,
    },
    {
        id: 2,
        en: "Total VAT:",
        ar: "إجمالي ضريبة القيمة المضافة" + " " + "( " + `${tax}` + "%" + ") ",
        amount: sta.tot.amountOfVat,
    },
    {
        id: 3,
        en: txtE.tot_net,
        ar: "الإجمالي شامل الضريبة",
        amount: sta.tot.tot_net + locInv.invs?.re_disc_minus,
    },
    // {
    //     id: 4,
    //     en: "Retention %",
    //     ar: "نسبة خصم ضمان الأعمال",
    //     amount: locInv?.desc_perc ?? 0,
    // },
    {
        id: 5,
        en: "Retention Amount",
        ar: "مبلغ خصم ضمان الأعمال",
        amount: locInv.invs?.re_disc_minus,
    },
    {
        id: 6,
        en: "Net Amount Payable",
        ar: "الصافي المطلوب دفعه",
        amount: sta.tot.tot_net,
    },
];
const totals = (sta ,tax) => [
    {
        en: "Total (Excluding VAT)",
        ar: "الإجمالي (باستثناء ضريبة القيمة المضافة)",
        amount: getTotalAmount(sta.tot),
    },
    {
        en: txtE.discount,
        ar: txtA.discount,
        amount: sta.tot.discount,
    },
    {
        en: "Amount After Discount",
        ar: "الاجمالي بعد الخصم",
        amount: getTotalAmount(sta.tot) - sta.tot?.discount,
    },
    {
        en: "Total VAT:",
        ar: "إجمالي ضريبة القيمة المضافة" + " " + "( " + `${tax}` + "%" + ") ",
        amount: sta.tot.amountOfVat,
    },
    {
        en: txtE.tot_net,
        ar: txtA.tot_net,
        amount: sta.tot.tot_net,
    },
];
const formatAmount = (value) =>
    Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

export default function InvoiceTotals(props) {
    const { sta, inv, premiApp, locInv } = props;
    const clas = useInvAF();

    const classes = useStyles();
    const totalsAll = () => {
        if (sta?.tot?.re_disc) {
            return totalsRe_Disc(sta,inv.tax, locInv);
        } else {
            return totals(sta, inv.tax);
        }
    };
    const intherTotals = () => {
        return (
            <>
                <Grid item container style={{ fontFamily: "Amiri-Regular" }}
                >
                    {premiApp.billTemplate !== 13 &&
                        <>
                            <Grid container item xs={6} className={clas.BdyborBtRTOPTotal2}>
                                {"اجمالي المدفوع"}    {"     :"}  {sta?.tot?.inv_type_name == "نقدية"
                                    ? sta?.tot?.tot_net?.toFixed(2)
                                    : sta?.tot?.paid}
                            </Grid>
                            <Grid container item xs={6} className={clas.BdyborBtRTOPTotal2}>
                                {"اجمالي المتبقي"}     {"     :"}            {sta.tot?.inv_type_name == "نقدية"
                                    ? 0
                                    : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
                            </Grid>
                        </>
                    }
                    {premiApp.billTemplate === 13 && (
                        <>
                            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
                                {"اجمالي المدفوع"}    {"     :"}  {sta?.tot?.inv_type_name == "نقدية"
                                    ? sta?.tot?.tot_net?.toFixed(2)
                                    : sta?.tot?.paid}
                            </Grid>
                            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
                                {"اجمالي المثبفي"}     {"     :"}            {sta.tot?.inv_type_name == "نقدية"
                                    ? 0
                                    : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
                            </Grid>

                            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
                                {"الرصيد قبل"}     {"     :"}
                                {inv.ProcType_InvProc === "11" || inv.ProcType_InvProc === "12" ? (parseFloat(sta.tot?.cust_balance_new) + parseFloat(inv.agel_part))?.toFixed(2)
                                    : (parseFloat(sta.tot?.cust_balance_new) - parseFloat(inv.agel_part))?.toFixed(2)}
                            </Grid>

                            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
                                {"الرصيد بعد"}     {"     :"}
                                {sta.tot?.cust_balance_new?.toFixed(2)}
                            </Grid>
                        </>
                    )}
                </Grid>
            </>
        )
    }
    return (
        <div style={{ paddingTop: "0.5rem" }}>
            <TableContainer component={Paper} className={classes.container}>
                <Table className={classes.table} aria-label="Invoice totals">
                    <TableBody >
                        {totalsAll().map((row) => (
                            <TableRow key={row.en}>
                                <TableCell
                                    className={`${classes.cell} ${classes.arabicCell}`}
                                >
                                    {row.ar}
                                </TableCell>
                                <TableCell
                                    className={`${classes.cell} ${classes.englishCell}`}
                                >
                                    {row.en}
                                </TableCell>
                                <TableCell
                                    className={`${classes.cell} ${classes.amountCell}`}
                                >
                                    <div className={classes.amountContent}>
                                        {row?.id != 4 && ["RS","SAR","SR","ريال سعودي"].includes(sta?.omlat[0]?.symbol) &&
                                            <span style={{ fontFamily: "SaudiRiyal", fontSize: 20 }}>{"\u20C1"}</span>
                                        }
                                        <span className={classes.amount}>
                                            {formatAmount(row.amount)}
                                        </span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
                {premiApp.billTemplate === 19 &&
                    (
                        <Grid item container xs={12} style={styleFooterNotesAr}>
                            {inv.notes}
                        </Grid>
                    )}
                    {!sta?.tot?.re_disc&& intherTotals()}
            </Grid>

        </div>
    );
}